import React from 'react';
import { Cancel, Check } from '@mui/icons-material';
import B2BDialog from './B2BDialog';
import useB2BTranslation from './hooks/useB2BTranslation';

const ConfirmationDialog = ({ title, mainText, open, onClose, onConfirm }) => {
    const { t } = useB2BTranslation('b2b-logbook');

    return (
        <B2BDialog open={open} title={title}
            onClose={onClose}
            buttons={[
                {
                    label: t('Confirm'),
                    onClick: (event) => {
                        event.stopPropagation();
                        onConfirm();
                    },
                    icon: <Check />
                },
                {
                    label: t('Cancel'),
                    onClick: (event) => {
                        event.stopPropagation();
                        onClose();
                    },
                    icon: <Cancel />
                },
            ]}
        >
            {mainText}
        </B2BDialog>
    );
};

export default ConfirmationDialog;